class APIS {
	apis() {
		return {
			fetchFaqs: {
				headers: {
					"xt-user-token": null,
				},
				method: "post",
				path: "/fetch/faqs",
			},
			fetchShareHolderRights: {
				headers: {
					"xt-user-token": null,
				},
				method: "post",
				path: "/fetch/shareholder",
			},
			fetchVideos: {
				headers: {
					"xt-user-token": null,
				},
				method: "get",
				path: "/fetch/shareholder/video/true",
			},
			fetchWebinars: {
				headers: {
					"xt-user-token": null,
				},
				method: "get",
				path: "/fetch/shareholder/webinar/true",
			},
			
		};
	}
}

export default new APIS();
